import { render, staticRenderFns } from "./elencoModifichePratica.vue?vue&type=template&id=22443134&"
import script from "./elencoModifichePratica.vue.ts?vue&type=script&lang=ts&"
export * from "./elencoModifichePratica.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports